import { useLanguage } from 'assets/languages';
import React from 'react';

interface ValidationStatusIndicatorProps {
  validationStatusCode: number;
  validationStatusMessage: string;
  openFeedbacksModal: () => void;
}

const ValidationStatusIndicator: React.FC<ValidationStatusIndicatorProps> = (props: {
  validationStatusCode: number;
  validationStatusMessage: string;
  openFeedbacksModal: () => void;
}) => {
  const language = useLanguage();
  const languageTexts = {
    ...language.component.postingCard.validationStatusIndicator,
  }

  const renderStatusMessageBox = () => {
    return <div className={'py-3.5 flex flex-row justify-center bg-[#f4f4f4]'}>
      <span className={'break-keep text-[17px] font-bold'}>{props.validationStatusMessage}</span>
    </div>;
  }

  const renderFeedbackBox = (description: React.ReactNode) => {
    return (
      <div className={'py-3.5 px-5 flex flex-col justify-center gap-2.5 text-center bg-[#b22a20] text-[#fff]'}>
        <strong>{props.validationStatusMessage}</strong>
        <p>{description}</p>
        <div className={'underline cursor-pointer'} onClick={() => props.openFeedbacksModal()}>
          {languageTexts.btn_open_feedbacks_modal}
        </div>
      </div>
    )
  }

  const renderValidatedBox = () => {
    return (
      <div className={'py-3.5 flex flex-row justify-center bg-[#1dcd00]'}>
        <span className={'break-keep text-white font-bold'}>{props.validationStatusMessage}</span>
      </div>
    )
  }

  return (
    <div className="text-sm">
      {
        [
          // VALIDATION_STATUS.INSPECTION_INITIAL(0)
          renderStatusMessageBox(),

          // VALIDATION_STATUS.INSPECTION_FIXED(1)
          renderStatusMessageBox(),

          // VALIDATION_STATUS.INSPECTION_VALIDATING(2)
          renderStatusMessageBox(),

          // VALIDATION_STATUS.VALIDATING(3)
          renderStatusMessageBox(),

          // VALIDATION_STATUS.MODIFYING(4)
          renderFeedbackBox(languageTexts._posting_status_modifying()),

          // VALIDATION_STATUS.REVALIDATING(5)
          renderFeedbackBox(languageTexts._posting_status_revalidating()),

          // VALIDATION_STATUS.VALIDATED(6)
          renderValidatedBox(),
        ][props.validationStatusCode]
      }
    </div>
  )
};

export default ValidationStatusIndicator;
